import { AuthService } from 'src/app/services/auth.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../../services/api.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-businesses',
  templateUrl: './businesses.page.html',
  styleUrls: ['./businesses.page.scss'],
})
export class BusinessesPage implements OnInit {
  businesses;
  category;
  show = 'todos';
  user;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private auth: AuthService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data['special']) {
      this.category = this.route.snapshot.data['special'];
    }
    if (this.route.snapshot.paramMap.get('id')) {
      this.getCategory();
    } else {
      this.getBusinesses();
    }

    this.auth.getUser().then((user) => {
      this.user = user;
    });
  }

  async getCategory() {
    //Get category from apiService
    const aux = (await this.apiService.getData('category/' + this.route.snapshot.paramMap.get('id'))).data || null;
    if (aux && JSON.stringify(aux) != JSON.stringify(this.category)) {
      this.category = aux;
      this.businesses = this.category.businesses;
    }
  }

  goToBusiness(business) {
    this.dataService.setData(business.id, business);
    this.router.navigate(['/tecservice/home/business', business.id]);
  }

  async getBusinesses() {
    const aux = (await this.apiService.getData('businesses')).data || null;
    if (aux && JSON.stringify(aux) != JSON.stringify(this.businesses)) this.businesses = aux;
  }

  showBorregos(value) {
    const regulars = document.getElementsByClassName('type_0');
    let i;
    if (value == true) for (i = 0; i < regulars.length; i++) regulars[i].setAttribute('hidden', 'true');
    else for (i = 0; i < regulars.length; i++) regulars[i].removeAttribute('hidden');
  }
}
